import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {
  constructor(private api: ApiService) {
  }

  getOptions(): Observable<any> {
    return this.api.post('UserAccess/options')
  }

  getAccessrights(sendData: any): Observable<any> {
    return this.api.post('UserAccess/getAccessData', sendData)
  }

  changeAccessGroup(sendData: any): Observable<any> {
    return this.api.post('UserAccess/changeAccessGroup', sendData)
  }

  changeAccessRights(sendData: any): Observable<any> {
    return this.api.post('UserAccess/changeAccessRights', sendData)
  }
}
